import styled from 'styled-components';
import { variant, justifyContent, margin } from 'styled-system';
import { TabProps, TabsStyleProps } from './types';

export const StyledContainer = styled.div`
  width: 100%;
`;

export const StyledTabsWrapper = styled.div<TabsStyleProps>`
  display: flex;
  ${justifyContent};
  ${margin};

  ${props =>
    props.variant === 'default' &&
    `background-color: ${props.theme.color.background}; 
    border-radius: ${props.theme.space[1]}px;
    height: 40px; 
    align-items: center; 
    padding: ${props.theme.space[1]}px;
    `}

  ${props =>
    props.variant === 'scheduled' &&
    `border-top: 1px solid ${props.theme.color.grey1}; 
    height: 68px;
    overflow-x: auto;
    overflow-y: hidden;
    `}

    ${props =>
    props.variant === 'block' &&
    ` overflow-x: auto;
      overflow-y: hidden;
      `}
`;

const activeCategoryTab = (isActive, theme) => (isActive ? theme.color.white : theme.color.headlineText);
const activeDefaultTab = (isActive, theme) => (isActive ? theme.color.white : theme.color.headlineText);
const activeUnderlinedTab = (isActive, theme) => (isActive ? theme.color.black : theme.color.grey0);

export const StyledTab = styled.span<TabProps>(
  props =>
    variant({
      prop: 'variant',
      variants: {
        category: {
          '& label': {
            color: props.isDisabledTab ? props.theme.color.disabled : activeCategoryTab(props.isActiveTab, props.theme),
            lineHeight: 'normal',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            fontSize: props.theme.fontSizes.body1,
          },
          background: props.isActiveTab ? props.theme.color.primary : props.theme.color.background,
          padding: `${props.theme.space[2]}px ${props.theme.space[3]}px`,
          margin: `0 ${props.theme.space[1]}px`,
          borderRadius: '50px',
          height: '36px',
        },
        default: {
          '& label': {
            color: props.isDisabledTab ? props.theme.color.disabled : activeDefaultTab(props.isActiveTab, props.theme),
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 'normal',
          },
          textAlign: 'center',
          cursor: 'pointer',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
          backgroundColor: props.isActiveTab && props.theme.color.primary,
          borderRadius: '4px',
          height: '32px',
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flex: 1,
        },
        scheduled: {
          height: '68px',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: props.isActiveTab ? props.theme.color.grey1 : props.theme.color.white,
          width: '100%',
          justifyContent: 'center',
          flexWrap: 'wrap',
          padding: '14px',
        },
        block: {
          '& label': {
            color: props.isDisabledTab ? props.theme.color.disabled : props.theme.color.black,
            opacity: !props.isActiveTab && '0.5',
          },
          cursor: 'pointer',
          textTransform: 'capitalize',
          height: '66px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          backgroundColor: props.isActiveTab ? `${props.theme.color.primary10}` : `${props.theme.color.headlineText}0D`,
          justifyContent: 'center',
          textAlign: 'center',
          padding: `${props.theme.space[4]}px 0`,
          borderRadius: `${props.theme.space[2]}px`,
          ...(props.isActiveTab && { border: `1px solid ${props.theme.color.primary}` }),
          marginInlineEnd: `${props.theme.space[4]}px`,
          minWidth: '145px',
        },
        underlined: {
          '& label': {
            color: props.isDisabledTab ? props.theme.color.disabled : activeUnderlinedTab(props.isActiveTab, props.theme),
            fontSize: props.theme.fontSizes.body1,
            lineHeight: '26px',
            fontWeight: props.theme.fontWeights.semiBold,
          },
          cursor: 'pointer',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
          backgroundColor: props.theme.color.white,
          borderBottom: props.isActiveTab && `solid 3px ${props.theme.color.primary}`,
          height: '50px',
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        },
      },
    }),
  props => ({ cursor: props.isDisabledTab ? 'default' : 'pointer', textTransform: 'capitalize' }),
);
